import api from '@/apis/di/topicAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid đề tài
export const useTopicComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onTopicComboboxLoadData = (payload, row, column) => {
    payload.sort = 'topic_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let ors1 = [{ Field: 'is_parent', Operator: 'NULL' }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: ors1 },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const topicComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã đề tài',
        dataField: 'topic_code',
        width: 160,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đề tài',
        dataField: 'topic_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 440,
      },
    ],
    quickAdd: 'TopicDetail',
    displayField: 'topic_code',
    valueField: 'topic_id',
    queryMode: 'remote',
    quickSearch: 'TopicQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive && !x.is_parent,
    },
    forceReload: true,
    dropdownWidth: 600,
    comboboxLoadData: onTopicComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    topicComboConfig,
    onTopicComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
